import { Button, CircularProgress } from '@mui/material';
import type { ButtonProps, SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { JSX, ReactNode } from 'react';


interface ILoadingButtonProps extends ButtonProps {
  loading?: boolean;
  loadingIndicator?: string;
  sx?: SxProps<Theme>;
  width?: string;
  children?: JSX.Element | JSX.Element[] | ReactNode;
}

interface IButtonProps extends ButtonProps {
  sx?: SxProps<Theme>;
  label?: string;
  width?: string;
  isLoading?: boolean;
}


export const SaveButton = ({
  type = 'submit',
  disabled = false,
  label = 'Save',
  width = '136px',
  isLoading = false,
  onClick,
  variant = 'contained',
  color = 'primary',
  sx,
  ...props
}: IButtonProps) => {
  const safeLoading = isLoading ?? false;
  return (
    <LoadingButton
      type={type}
      disabled={disabled}
      loading={safeLoading}
      color={color}
      variant={variant}
      sx={{
        width,
        marginRight: '5px',
        opacity: 0.97,
        '&:hover': {
          opacity: 1,
        },
        ...sx,
      }}
      {...(onClick && { onClick })}
      {...props}
    >
      {label}
    </LoadingButton>
  );
};


export const CancelButton = ({
  disabled = false,
  label = 'Cancel',
  onClick,
  variant = 'outlined',
  color = 'error',
  width = '136px',
  sx,
}: IButtonProps) => {
  return (
    <Button
      color={color}
      variant={variant}
      disabled={disabled}
      sx={{ width, marginRight: '5px', ...sx }}
      {...(onClick && { onClick })}
    >
      {label}
    </Button>
  );
};


export const LoadingButton = ({
  disabled = false,
  loading = false,
  loadingIndicator = '',
  onClick,
  children,
  variant = 'outlined',
  color = 'primary',
  width = 'auto',
  sx,
  ...props
}: ILoadingButtonProps) => {
  return (
    <Button
      color={color}
      variant={variant}
      disabled={loading || disabled}
      sx={{ width, ...sx }}
      {...(onClick && { onClick })}
      {...props}
    >
      {loading ? (
        loadingIndicator ? (
          <>{loadingIndicator}</>
        ) : (
          <CircularProgress color="inherit" size={20} />
        )
      ) : (
        children
      )}
    </Button>
  );
};